import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormatter',
})

export class NumberFormatterPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || isNaN(value)) return value;

    const numValue = typeof value === 'string' ? parseFloat(value) : Number(value);
    const rounded = Math.round(numValue);

    // Fix: Treat -0 as 0
    const displayValue = Object.is(rounded, -0) ? 0 : rounded;

    const formatter = new Intl.NumberFormat('en-US', {
      maximumFractionDigits: 0,
      minimumFractionDigits: 0
    });

    return formatter.format(displayValue);
  }
}
 